// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OAuthApplicationsQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type OAuthApplicationsQuery = {
  __typename?: "GraphqlQuery";
  getOauthApplications: Array<{
    __typename?: "OauthApplication";
    id: string;
    name: string;
    scopes: string;
    organizationName: string;
    organizationSlug: string;
    createdAt: number;
    lastUsedAt?: number | null;
  }>;
};

export const OAuthApplicationsDocument = gql`
  query OAuthApplications($organizationSlug: ID!) {
    getOauthApplications(organizationSlug: $organizationSlug) {
      id
      name
      scopes
      organizationName
      organizationSlug
      createdAt
      lastUsedAt
    }
  }
`;

/**
 * __useOAuthApplicationsQuery__
 *
 * To run a query within a React component, call `useOAuthApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthApplicationsQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOAuthApplicationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OAuthApplicationsQuery,
    OAuthApplicationsQueryVariables
  > &
    (
      | { variables: OAuthApplicationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OAuthApplicationsQuery,
    OAuthApplicationsQueryVariables
  >(OAuthApplicationsDocument, options);
}
export function useOAuthApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuthApplicationsQuery,
    OAuthApplicationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OAuthApplicationsQuery,
    OAuthApplicationsQueryVariables
  >(OAuthApplicationsDocument, options);
}
// @ts-ignore
export function useOAuthApplicationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OAuthApplicationsQuery,
    OAuthApplicationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OAuthApplicationsQuery,
  OAuthApplicationsQueryVariables
>;
export function useOAuthApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OAuthApplicationsQuery,
        OAuthApplicationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OAuthApplicationsQuery | undefined,
  OAuthApplicationsQueryVariables
>;
export function useOAuthApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OAuthApplicationsQuery,
        OAuthApplicationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OAuthApplicationsQuery,
    OAuthApplicationsQueryVariables
  >(OAuthApplicationsDocument, options);
}
export type OAuthApplicationsQueryHookResult = ReturnType<
  typeof useOAuthApplicationsQuery
>;
export type OAuthApplicationsLazyQueryHookResult = ReturnType<
  typeof useOAuthApplicationsLazyQuery
>;
export type OAuthApplicationsSuspenseQueryHookResult = ReturnType<
  typeof useOAuthApplicationsSuspenseQuery
>;
export type OAuthApplicationsQueryResult = Apollo.QueryResult<
  OAuthApplicationsQuery,
  OAuthApplicationsQueryVariables
>;
